import Vue from 'vue'
import Templete from './index.vue'

Vue.use({
    install (Vue) {
        const Constructor = Vue.extend(Templete)

        Vue.prototype.$message = 
        window.$message = (text, options = {}) => {

            options.text = String(text)

            let instance = new Constructor({
                propsData: options
            })

            instance.$mount()
            document.body.appendChild(instance.$el)
        }
    }
})